import React from 'react';
import { Link } from 'react-router-dom';
import { Search, Tag, Wallet, Star, MessageSquare, Download } from 'lucide-react';

const STEPS = [
  {
    n: '01',
    Icon: Search,
    title: 'Browse & install.',
    body: 'Find a skill package for the job — RAG eval, agent memory, scrapers, and more. Download it as a ready-to-drop .claude/skills/ bundle. Free skills are one click; paid skills are a quick checkout.',
    tag: 'For buyers',
  },
  {
    n: '02',
    Icon: Tag,
    title: 'Sell your skills.',
    body: 'List a package you generated with the API, uploaded, or pasted in. Set a price (or make it free), add a description, and publish. Buyers can rate it, review it, and message you.',
    tag: 'For sellers',
  },
  {
    n: '03',
    Icon: Wallet,
    title: 'Earn 80%.',
    body: 'Every sale settles to your connected payout account — you keep 80%, the platform takes a 20% fee. Track downloads, sales, and earnings per skill from your seller dashboard.',
    tag: 'Get paid',
  },
];

const PERKS = [
  { Icon: Star, label: '5-star ratings & reviews' },
  { Icon: Download, label: 'Download counts + leaderboard' },
  { Icon: MessageSquare, label: 'Message buyers & sellers' },
];

export default function MarketplaceHow() {
  return (
    <section className="relative border-t border-[var(--border)] bg-[var(--bg-2)]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-28 md:py-32">
        <div className="flex items-center gap-3 mb-12 text-[var(--text-3)]">
          <span className="divider-num">(06)</span>
          <span className="eyebrow">How it works</span>
          <span className="flex-1 thin-line ml-2" />
        </div>

        <h2 className="serif text-[2.6rem] md:text-[4rem] leading-[1.04] tracking-[-0.02em] mb-16 max-w-[18ch]">
          A two-sided market for <span className="italic text-[var(--text-2)]">agent skills.</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[var(--border)] border border-[var(--border)] rounded-sm overflow-hidden mb-12">
          {STEPS.map((s) => {
            const { Icon } = s;
            return (
              <div key={s.n} className="bg-[var(--bg)] p-8 md:p-10 flex flex-col">
                <div className="flex items-center justify-between mb-7">
                  <span className="mono text-[0.72rem] tracking-[0.18em] uppercase text-[var(--text-4)]">{s.n}</span>
                  <span className="mono text-[0.64rem] tracking-[0.16em] uppercase px-2.5 py-1 rounded-full border border-[var(--border-2)] text-[var(--accent)]">{s.tag}</span>
                </div>
                <Icon size={26} className="text-[var(--accent)] mb-5" />
                <h3 className="serif text-[1.9rem] leading-tight mb-3">{s.title}</h3>
                <p className="text-[var(--text-2)] text-[0.94rem] leading-[1.65] flex-1">{s.body}</p>
              </div>
            );
          })}
        </div>

        <div className="flex flex-wrap items-center justify-between gap-6">
          <div className="flex flex-wrap items-center gap-x-8 gap-y-3 text-[var(--text-3)]">
            {PERKS.map(({ Icon, label }) => (
              <span key={label} className="inline-flex items-center gap-2 mono text-[0.72rem] tracking-[0.12em] uppercase">
                <Icon size={14} className="text-[var(--accent)]" /> {label}
              </span>
            ))}
          </div>
          <div className="flex items-center gap-3">
            <Link to="/dashboard/sell" className="btn-primary !py-2.5 !px-5 !text-[0.88rem]">
              <Tag size={15} /> Start selling
            </Link>
            <Link to="/marketplace" className="btn-ghost !py-2.5 !px-5 !text-[0.88rem]">
              <Search size={15} /> Explore skills
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
